import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../../common/redux/hooks";
import { containsError } from "../../../../../../common/redux/reducers/contractReducer";
import { editContractThunk } from "../../../../../../common/redux/thunks/contract/edit-contract-thunk";
import { requireDataFields } from "../../../../typeguards";
import { useContractState } from "../../../useContractState";
import { GenericMonetaryValue } from "./GenericMonetaryValue";

interface Props {
  removeDataField?: () => Promise<void>;
  isRequiredButNotProvided: boolean;
}

export const TotalPrice: React.FC<Props> = ({ removeDataField, isRequiredButNotProvided }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const contractState = useContractState();
  const dataFields = requireDataFields(contractState.contract);
  const amount = dataFields.totalPrice ?? null;
  const errorMessage = containsError(contractState, "EditTotalPrice") ? t("Update failed") : null;

  return (
    <GenericMonetaryValue
      label={t("Total price")}
      placeholderText={""}
      helperText={t("Provide the total price of the contract")}
      amount={amount}
      errorMessage={errorMessage}
      editAmount={async (newAmount) => {
        await dispatch(
          editContractThunk({
            command: {
              type: "EditTotalPrice",
              value: newAmount ?? null,
            },
          })
        );
      }}
      removeDataField={removeDataField}
      isRequiredButNotProvided={isRequiredButNotProvided}
      wholeAmountsOnly
    />
  );
};
